webpackJsonp([53125558880568],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/case-studies/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _section, _section2, _caseStudy, _caseStudyInner, _caseStudyInnerDescri, _caseStudyStat;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseStudies = function (_React$Component) {
	  _inherits(CaseStudies, _React$Component);
	
	  function CaseStudies() {
	    _classCallCheck(this, CaseStudies);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CaseStudies.prototype.render = function render() {
	    var caseStudies = this.props.data.allPrismicDocument.edges;
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(
	        _reactHelmet.Helmet,
	        { title: 'Case Studies' },
	        Glamor.createElement('meta', { name: 'description', content: 'Read why more companies are switching to CarePlanner.' }),
	        Glamor.createElement('meta', { property: 'og:type', content: 'website' }),
	        Glamor.createElement('meta', { property: 'og:title', content: 'Case Studies on CarePlanner' }),
	        Glamor.createElement('meta', { property: 'og:description', content: 'Read why more companies are switching to CarePlanner.' }),
	        Glamor.createElement('meta', { name: 'twitter:title', content: 'Case Studies on CarePlanner' }),
	        Glamor.createElement('meta', { name: 'twitter:description', content: 'Read why more companies are switching to CarePlanner.' })
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section1 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'h1',
	            null,
	            'Case Studies'
	          ),
	          Glamor.createElement(
	            'p',
	            { css: _globalStyles2.default.sectionDescriptionTop },
	            'Read why more companies are switching to CarePlanner.'
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section2, itemScope: true, itemType: 'http://schema.org/ItemList' },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          caseStudies.map(function (caseStudy, i) {
	            return Glamor.createElement(
	              'div',
	              { css: styles.caseStudy, key: i, onClick: function onClick() {
	                  return (0, _gatsbyLink.navigateTo)(caseStudy.node.fields.permalink);
	                }, itemProp: 'itemListElement' },
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyInner },
	                Glamor.createElement('img', { css: styles.caseStudyInnerImg, src: caseStudy.node.data.large_image.url, alt: 'Quote from {caseStudy.node.data.company_name.text}' }),
	                Glamor.createElement(
	                  'h3',
	                  { itemProp: 'name' },
	                  _prismicDom2.default.RichText.asText(caseStudy.node.data.company_name)
	                ),
	                Glamor.createElement('div', { css: styles.caseStudyInnerDescription, dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.node.data.summary) } }),
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { to: caseStudy.node.fields.permalink },
	                  'Read Case Study...'
	                )
	              ),
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyStat },
	                Glamor.createElement(
	                  'div',
	                  { css: styles.caseStudyStatFigure },
	                  caseStudy.node.data.key_stat_figure
	                ),
	                Glamor.createElement(
	                  'div',
	                  { css: styles.caseStudyStatDescription },
	                  caseStudy.node.data.key_stat_text
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return CaseStudies;
	}(_react2.default.Component);
	
	exports.default = CaseStudies;
	;
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var styles = {
	  section1: (_section = {
	    background: '#F4F8FC'
	  }, _section[_presets2.default.Desktop] = {
	    width: 'calc(100% - 200px)',
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    width: 'calc(100% - 200px)',
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    width: 'calc(100% - 100px)',
	    padding: '70px 50px'
	  }, _section),
	  section2: (_section2 = {}, _section2[_presets2.default.Desktop] = {
	    padding: '0 100px 50px',
	    '&:hover > * > *': {
	      opacity: .6
	    },
	    '&:hover > * > *:hover': {
	      opacity: 1
	    }
	  }, _section2[_presets2.default.Tablet] = {
	    paddingBottom: '50px'
	  }, _section2[_presets2.default.Mobile] = {
	    padding: '0 10px'
	  }, _section2),
	  caseStudy: (_caseStudy = {}, _caseStudy[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '29%',
	    width: '29%',
	    margin: '4% 1.9% 0 1.9%',
	    '-moz-transition': 'opacity .2s',
	    '-o-transition': 'opacity .2s',
	    '-webkit-transition': 'opacity .2s',
	    transition: 'opacity .2s'
	  }, _caseStudy[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '29%',
	    width: '29%',
	    margin: '4% 1.9% 0 1.9%'
	  }, _caseStudy[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _caseStudy),
	  caseStudyInner: (_caseStudyInner = {
	    width: 'calc(100% - 40px)',
	    padding: '20px',
	    marginBottom: '20px',
	    cursor: 'pointer'
	  }, _caseStudyInner[_presets2.default.Desktop] = {
	    maxHeight: '324px',
	    height: '324px'
	  }, _caseStudyInner[_presets2.default.Tablet] = {
	    maxHeight: '324px',
	    height: '324px'
	  }, _caseStudyInner),
	  caseStudyInnerImg: {
	    width: '100%'
	  },
	  caseStudyInnerDescription: (_caseStudyInnerDescri = {}, _caseStudyInnerDescri[_presets2.default.Desktop] = {
	    maxHeight: '141px',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }, _caseStudyInnerDescri[_presets2.default.Tablet] = {
	    maxHeight: '141px',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }, _caseStudyInnerDescri),
	  caseStudyStat: (_caseStudyStat = {
	    width: 'calc(100% - 40px)',
	    padding: '20px',
	    background: '#F4F8FC',
	    cursor: 'pointer'
	  }, _caseStudyStat[_presets2.default.Desktop] = {
	    height: '108px',
	    maxHeight: '108px'
	  }, _caseStudyStat[_presets2.default.Tablet] = {
	    height: '108px',
	    maxHeight: '108px'
	  }, _caseStudyStat),
	  caseStudyStatFigure: {
	    fontSize: '36px',
	    color: '#4F739A',
	    textAlign: 'center',
	    margin: '10px 0'
	  },
	  caseStudyStatDescription: {
	    textAlign: 'center',
	    margin: '10px'
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-studies-index-js-d63fd281eb06827d4f96.js